import React, { memo, useEffect, useRef } from 'react';
import { RotatingLines } from 'react-loader-spinner';
import clsx from 'clsx';

import CommonCarousel from '../../../../components/common-carousel/CommonCarousel';
import EmptyMessagesList from '../../../../resonance/components/messages-list/EmptyMessagesList';

import scss from './FrameSlider.module.scss';

function FrameSlider({
  onPreview,
  images,
  onLike,
  onDownload,
  height,
  minHeight,
  onSwipe,
  initialIndex,
  isGenerating,
  slideImageClassName,
  slideClassName,
  currentIndex,
  sliderWrapperClassName,
  Slide,
  contrastedArrows,
  enableArrowNavigation,
  onShowSourceImage,
}) {
  const carouselRef = useRef(null);

  const sortedSlides = [...images].sort((a, b) => {
    const reactionDiff = Number(!!b.reaction) - Number(!!a.reaction);
    if (reactionDiff !== 0) return reactionDiff;

    return new Date(b.updatedOn) - new Date(a.updatedOn);
  });

  const handleLike = (slide) => {
    onLike(slide);

    carouselRef.current?.goToSlide(0);
  };

  useEffect(() => {
    if (typeof currentIndex === 'number') {
      carouselRef.current?.goToSlide(currentIndex);
    }
  }, [currentIndex]);

  return (
    <div className={clsx(scss.sliderWrapper, sliderWrapperClassName)} style={{ height, minHeight }}>
      {sortedSlides.length ? (
        <CommonCarousel
          ref={carouselRef}
          onBeforeChange={onSwipe}
          initialSlide={initialIndex}
          isLazyLoad
          draggable={!isGenerating}
          contrastedArrows={contrastedArrows}
          swipe={!isGenerating}
          enableArrowNavigation={enableArrowNavigation}>
          {sortedSlides.map((slide) => (
            <Slide
              key={slide.id}
              slide={slide}
              onPreview={onPreview}
              onLike={handleLike}
              onDownload={onDownload}
              disabled={isGenerating}
              slideClassName={slideClassName}
              slideImageClassName={slideImageClassName}
              onShowSourceImage={onShowSourceImage}
            />
          ))}
        </CommonCarousel>
      ) : (
        <div className={scss.emptySlide}>
          <EmptyMessagesList />
        </div>
      )}

      {isGenerating && (
        <div className={scss.loaderWrapper}>
          <RotatingLines strokeColor='#fdbf47' strokeWidth={5} animationDuration='0.75' width={28} visible={true} />
        </div>
      )}
    </div>
  );
}

export default memo(FrameSlider);
